import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import {
  ProductDetailsColumnsIds,
  ProductInventory
} from '@setvi/shared/interfaces';
import {
  Quantity,
  Badge
} from 'componentsV2/product/details/content/subpages/warehouse/columns-content/components';
import { Customer } from 'Services/Mongo/Types';

interface WarehouseCellContentProps {
  id: ProductDetailsColumnsIds;
  row: ProductInventory;
  selectedCustomer?: Customer;
  label: string;
  getWarehouseLocation: (warehouse: ProductInventory['warehouse']) => string;
}

export const getWarehouseCellContent = ({
  id,
  row,
  selectedCustomer,
  label,
  getWarehouseLocation
}: WarehouseCellContentProps) => {
  const contents = {
    [ProductDetailsColumnsIds.Location]: (
      <Box display="flex" alignItems="center">
        <SText
          weight="bold"
          maxLines={2}
          title={getWarehouseLocation(row.warehouse)}
        />
        {row.warehouseId === selectedCustomer?.warehouse?.code && (
          <Badge>Home DC</Badge>
        )}
      </Box>
    ),
    [ProductDetailsColumnsIds.OrderedQuantity]: (
      <Quantity row={row} prefix={`${label}: `} property="orderedQuantity" />
    ),
    [ProductDetailsColumnsIds.OnOrderQuantity]: (
      <Quantity row={row} prefix={`${label}: `} property="onOrderQuantity" />
    ),
    [ProductDetailsColumnsIds.OnHandQuantity]: (
      <Quantity row={row} prefix={`${label}: `} property="onHandQuantity" />
    ),
    [ProductDetailsColumnsIds.OnTransferQuantity]: (
      <Quantity row={row} prefix={`${label}: `} property="onTransferQuantity" />
    ),
    [ProductDetailsColumnsIds.Stock]: (
      <Quantity row={row} prefix={`${label}: `} property="availableOnHand" />
    )
  };

  return contents[id];
};
